import { useForm, Controller } from "react-hook-form";
import Container from "../../componentes/Container";
import BarraDeNavegacao from "../../componentes/BarraDeNavegacao";
import {
  BotaoComTextoEIcone,
  GerenciadorDeMensagem,
} from "@digix-ui/componentes";
import { CampoDeTexto } from "../../componentes";
import { useHistory, useParams } from "react-router-dom";
import React from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { buscarProjetoPorId } from "./services/buscarProjetoPorId";
import "./styles.scss";
import { formatarData } from "./utils/formatarData";
import { editarProjeto } from "./services/editarProjeto";

interface ProjetoFormData {
  nome: string;
  idPrograma: string;
  descricao: string;
  dataInicio?: string;
  dataFim?: string;
  textoDeCiencia: string;
}

const EditarProjeto = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const { control, handleSubmit, reset } = useForm<ProjetoFormData>({
    defaultValues: {
      nome: "",
      idPrograma: "",
      descricao: "",
      dataInicio: "",
      dataFim: "",
      textoDeCiencia: "",
    },
  });

  const voltarParaListagemDeProjetos = () => {
    history.push("/gerenciar-locais-permissoes?aba=projetos");
  };

  const { data: projetoData, isLoading } = useQuery({
    queryKey: ["projeto", id],
    queryFn: () => buscarProjetoPorId(Number(id)),
    enabled: !!id,
  });

  const { mutate } = useMutation({
    mutationFn: editarProjeto,
    onSuccess: () => {
      GerenciadorDeMensagem.criarMensagem({
        tipo: "sucesso",
        icone: "far fa-check-circle",
        titulo: "Tudo certo!",
        texto: "Projeto editado com sucesso",
      });
      voltarParaListagemDeProjetos();
    }
  });

  React.useEffect(() => {
    if (projetoData) {
      reset({
        nome: projetoData.nome,
        idPrograma: projetoData.idPrograma.toString(),
        descricao: projetoData.descricao,
        dataInicio: formatarData(projetoData.dataInicio || ''),
        dataFim: formatarData(projetoData.dataFim || ''),
        textoDeCiencia: projetoData.textoDeCiencia,
      });
    }
  }, [projetoData, reset]);

  function onSubmit(data: ProjetoFormData) {
    const payload = {
      id: Number(id),
      ...data,
      idPrograma: Number(data.idPrograma),
    };

    mutate(payload);
  }

  if (isLoading)
    return <p style={{ padding: "2rem" }}>Carregando projeto...</p>;

  return (
    <>
      <BarraDeNavegacao titulo="Editar projeto" comBotaoADireita={false} />
      <Container comFundo tamanhoDoContainer="grande">
        <form className="formulario" onSubmit={handleSubmit(onSubmit)}>
          <h2 className="cartao__titulo">Informações do projeto</h2>

          <div className="grade__linha u-margem-superior-media">
            <Controller
              name="nome"
              control={control}
              render={({ field }) => (
                <CampoDeTexto {...field} label="Nome do projeto" colunas="6" />
              )}
            />
            <Controller
              name="idPrograma"
              control={control}
              render={({ field }) => (
                <div className="campo-de-texto u-coluna-6">
                  <label className="campo-de-texto__rotulo">Programa</label>
                  <select
                    {...field}
                    className="campo-de-texto__input"
                    onChange={(e) => field.onChange(e.target.value)}
                    value={field.value}
                  >
                    <option value="1">MS CIDADÃO CASA DA GENTE</option>
                  </select>
                </div>
              )}
            />
          </div>

          <div className="campo-de-texto--longo u-margem-superior-pequena">
            <Controller
              name="descricao"
              control={control}
              render={({ field }) => (
                <CampoDeTexto {...field} label="Descrição" />
              )}
            />
          </div>

          <div className="grade__linha u-margem-superior-pequena">
            <Controller
              name="dataInicio"
              control={control}
              render={({ field }) => (
                <CampoDeTexto
                  {...field}
                  value={field.value ?? ""}
                  tipo="date"
                  label="Data de início"
                />
              )}
            />
            <Controller
              name="dataFim"
              control={control}
              render={({ field }) => (
                <CampoDeTexto
                  {...field}
                  value={field.value ?? ""}
                  tipo="date"
                  label="Data de fim"
                  colunas="6"
                />
              )}
            />
          </div>

          <div className="campo-de-texto--longo u-margem-superior-media">
            <Controller
              name="textoDeCiencia"
              control={control}
              render={({ field }) => (
                <CampoDeTexto {...field} label="Texto de ciência" />
              )}
            />
          </div>

          <div className="formulario__botoes u-margem-top-grande">
            <BotaoComTextoEIcone
              tamanho="pequeno"
              cor="secundaria"
              tipo="button"
              icone="far fa-arrow-left"
              posicaoDoIcone="esquerda"
              onClick={voltarParaListagemDeProjetos}
            >
              Voltar
            </BotaoComTextoEIcone>

            <BotaoComTextoEIcone
              tamanho="pequeno"
              cor="sucesso"
              tipo="submit"
              icone="far fa-check"
              posicaoDoIcone="esquerda"
            >
              Salvar
            </BotaoComTextoEIcone>
          </div>
        </form>
      </Container>
    </>
  );
};

export default EditarProjeto;
